import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialRelationModalState } from "./initializes";
import type { RelationModal, RelationInfo, ConnectDataInfo } from "./types";

const relationModalSlice = createSlice({
  name: "RelationModal",
  initialState: initialRelationModalState,
  reducers: {
    setRelationInfo: (state: RelationModal, action: PayloadAction<RelationInfo>) => {
      state.relationInfo = action.payload;
    },
    setIsShownRelationModal: (state: RelationModal, action: PayloadAction<boolean>) => {
      state.isShown = action.payload;
    },
    setConnectDataInfo: (state: RelationModal, action: PayloadAction<ConnectDataInfo>) => {
      state.connectDataInfo = action.payload;
    },
  },
});

export const { setRelationInfo, setIsShownRelationModal, setConnectDataInfo } = relationModalSlice.actions;

export default relationModalSlice.reducer;
